import { useQuery } from "react-query";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { uuidv4 } from "../../../../../utils";

const getCommercialData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const { info: userInfo } = Digit.UserService.getUser();

 
    const applicationData = {
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: applicationFlow || null,
    };

    return { applicationData, isAppDataLoading: false };
  
};

export default getCommercialData;
